module.exports = __webpack_public_path__ + "img/symbol_3.6e421b7d.png";